import React from 'react';
import { TabTableContainer } from '@screens/players/player.details.tabs/tabs.tables.styles';
import { useAuth } from '@domain/auth/auth.hook';
import { AxiosResponse, CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { noopArray } from '@domain/utils/function.utils';
import { MainDataGrid } from '@components/datagrid/main.data.grid';
import { PlayerDataProps } from '@screens/players/types/player.data.props';

const columns = [
  { field: 'association', headerName: 'Association', width: 180 },
  { field: 'timestamp', headerName: 'Timestamp', width: 180 },
  { field: 'platform', headerName: 'Platform', width: 135 },
  { field: 'logins', headerName: 'Logins', width: 120 },
  { field: 'version', headerName: 'Version', width: 125 },
  { field: 'deviceBrand', headerName: 'Device Brand', width: 180 },
  { field: 'deviceType', headerName: 'Device Type', width: 180 },
  { field: 'osVersion', headerName: 'OS Version', width: 150 },
  { field: 'carrier', headerName: 'Carrier', width: 150 },
];

interface HandwareInfo {
  pid: number;
  association: string;
  timestamp: string;
  platform: string;
  logins: number;
  version: string;
  deviceBrand: string;
  deviceType: string;
  osVersion: string;
  carrier: string;
}

let index = 0;
function createData(info: HandwareInfo) {
  index += 1;
  return { id: index, ...info };
}

const Hardware = ({ player }: PlayerDataProps) => {
  const { authorizedServices } = useAuth();
  const { pid } = player;

  async function runSearch(requestPid: number, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices
      .get<HandwareInfo[]>(`/admin/player/hardware/${requestPid}`, { cancelToken })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) return { ...error.response, data: [] } as AxiosResponse<HandwareInfo[]>;
        throw error;
      });
  }

  const { responseData, pageCount, loading, error } = usePagedData(pid, runSearch, { placeholderData: noopArray });
  const rows = responseData?.map(createData) || [];
  // const rows = responseData || [];

  return (
    <>
      <TabTableContainer>
        <MainDataGrid columns={columns} rows={rows} loading={loading} error={error} pageCount={pageCount} />
      </TabTableContainer>
    </>
  );
};

export default Hardware;
